import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';


@Component({
  selector: 'page-modal-editar-texto',
  templateUrl: 'modal-editar-texto.html'
})
export class ModalEditarTextoPage {
  objetoRetorno: any = {
    salvar: false,
    texto: ''
  };

  isCGE: any;
  isJurisdicionado: any;
  parecer: any;

  analise: any = null;

  constructor(private viewCtrl: ViewController,
    public navParams: NavParams) {

    this.objetoRetorno = {
      salvar: false,
      texto: ""
    };

    this.analise = this.navParams.get('analise');
    this.objetoRetorno.texto = this.navParams.get('texto');
    this.isCGE = this.navParams.get('isCGE');
    this.isJurisdicionado = this.navParams.get('isJurisdicionado');
    this.parecer = this.navParams.get('parecer');

    // if (!this.parecer) {
    //   this.parecer = true;
    // }

  }

  cancelar() {
    this.objetoRetorno.salvar = false;
    this.viewCtrl.dismiss(this.objetoRetorno);
  }

  salvar() {
    this.objetoRetorno.salvar = true;

    this.objetoRetorno.texto = this.capitalize(this.objetoRetorno.texto);

    this.viewCtrl.dismiss(this.objetoRetorno);
  }

  capitalize(str) {
    let retorno = "";

    if (str) {
      retorno = str.charAt(0).toUpperCase() + str.slice(1);
    }

    return retorno;
  }

}


// WEBPACK FOOTER //
// ./src/pages/modais/modal-editar-texto/modal-editar-texto.ts